import { Maybe, Membership, MembersSortType, Release, SortDirection } from '~/api/generated/graphql'

const EARLY_START_MINUTES = 10

export const sortReleases = (releaseOrderRaw: Maybe<string>, releases: Partial<Maybe<Release>>[] | undefined) => {
  if (!releaseOrderRaw) return releases
  const releaseOrder = JSON.parse(releaseOrderRaw) as string[]
  const releasesToSort = [...(releases ?? [])]
  return (
    releasesToSort?.sort((a, b) => {
      const aIndex = releaseOrder.indexOf(a?.releaseId ?? '')
      const bIndex = releaseOrder.indexOf(b?.releaseId ?? '')
      if (aIndex === -1) return 1
      if (bIndex === -1) return -1
      return aIndex - bIndex
    }) ?? []
  )
}

export const sortMembershipByName = (memberships: Membership[], sortDirection: SortDirection): Membership[] => {
  return [...memberships].sort((a: Membership, b: Membership) => {
    const direction = sortDirection == SortDirection.Asc ? 1 : -1

    const firstNameA = a.user?.firstName?.toLowerCase() || ''
    const firstNameB = b.user?.firstName?.toLowerCase() || ''
    const lastNameA = a.user?.firstName?.toLowerCase() || ''
    const lastNameB = b.user?.firstName?.toLowerCase() || ''

    if (firstNameA < firstNameB) return 1 * direction
    if (firstNameA > firstNameB) return -1 * direction
    if (lastNameA < lastNameB) return 1 * direction
    if (lastNameA > lastNameB) return -1 * direction

    return 0
  })
}
/*
 * Utility to sort memberships. This was written to sort new members when added to a community. mimicks the server
 * */
export const sortMemberships = (
  memberships: Membership[],
  sortType: MembersSortType,
  sortDirection: SortDirection
): Membership[] => {
  let membershipsToSort = [...memberships]
  const direction = sortDirection == SortDirection.Asc ? 1 : -1

  if (sortType == MembersSortType.Leader) {
    const sortFields: (keyof Membership)[] = ['accountLead', 'commercialLead', 'rdqLead', 'leader']
    const sortedFields: Membership[][] = []

    // Split memberships into each field type to sort individually
    for (const field of sortFields) {
      sortedFields.push(membershipsToSort.filter(a => a[field]))
      membershipsToSort = membershipsToSort.filter(a => a[field] == false)
    }

    sortedFields.push(membershipsToSort)

    for (const [i, fields] of sortedFields.entries()) {
      sortedFields[i] = sortMembershipByName(fields, sortDirection)
    }

    if (sortDirection == SortDirection.Asc) sortedFields.reverse()

    return sortedFields.flat()
  } else if (sortType == MembersSortType.Company) {
    return membershipsToSort.sort((a: Membership, b: Membership) => {
      const firstNameA = a.user?.company?.name?.toLowerCase() || ''
      const firstNameB = b.user?.company?.name?.toLowerCase() || ''

      if (firstNameA > firstNameB) return 1 * direction
      if (firstNameA < firstNameB) return -1 * direction

      return 0
    })
  }

  return sortMembershipByName(membershipsToSort, sortDirection)
}

export const eventStartDelta = (event: { eventStart: string }): number => {
  const now = new Date()
  const start = new Date(event?.eventStart)
  return start.getTime() - now.getTime() - EARLY_START_MINUTES * 60 * 1000
}

export const eventHasStartHandler = (
  event: {
    eventStart: string
    livestreamStart: boolean
  },
  callback: React.Dispatch<React.SetStateAction<boolean>>,
  isVeevan: boolean
): (() => void) => {
  const startDelta = eventStartDelta(event)
  const hasPassed = startDelta <= 0 || (isVeevan && event.livestreamStart)
  if (hasPassed) {
    callback(false)
    return () => {}
  } else {
    callback(true)
    console.log('setting timeout for', startDelta)
    const i = setTimeout(() => {
      callback(false)
    }, startDelta)
    return () => {
      clearTimeout(i)
    }
  }
}
